import OrderPlacedBanner from './order-placed-banner';

export default OrderPlacedBanner;
